module.exports = __webpack_public_path__ + "media/img/corporate/pac1-80f5a93535002944b829bdaba3afa20d.svg";